/** @format **/
import React, { FunctionComponent, ReactElement, useState } from 'react';
import MvnoBlockContain from '../../interfaces/platform/MvnoBlockContain';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import { Dialog, DialogActions, DialogContent, TextareaAutosize, Typography } from '@material-ui/core';
import CustomInputExtNumber from '../../components/CustomInput/CustomInputExtNumber';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { useDispatch } from 'react-redux';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import MvnoBlockListInterface from '../../interfaces/platform/MvnoBlockListInterface';
import { useBlockFunctionList } from '../../modules/lib/hooks/useBlockFunctionList';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import { SimpleSelect, SimpleSelectElements } from '../../components/Adescom/SimpleSelect';

type MvnoBlockContainsJsonAddType = {
    mvnoBlockList: MvnoBlockListInterface;
    reloadContainsList(): void;
    closeCallback(): void;
    open: boolean;
};

export const MvnoBlockContainsJsonAdd: FunctionComponent<MvnoBlockContainsJsonAddType> = ({
    mvnoBlockList,
    reloadContainsList,
    open,
    closeCallback,
}): ReactElement => {
    const dispatch = useDispatch();
    const [containsConditions, setContainsConditions] = useState('{}');
    const [containsSleepSeconds, setContainsSleepSeconds] = useState<number>(0);
    const [containsPositionId, setContainsPositionId] = useState<number>(1);
    const [containsBlockFunctionId, setContainsBlockFunctionId] = useState<number>(-1);

    const functionList = useBlockFunctionList();

    const functionElements: Array<SimpleSelectElements> = [];
    if (functionList && functionList['hydra:member']) {
        for (let i = 0; i < functionList['hydra:member']?.length; i++) {
            functionElements.push({
                name: functionList['hydra:member'][i].displayName,
                value: functionList['hydra:member'][i].id,
            });
        }
    }

    const onChangeSelectEvent = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const field = event.target.name;
        const selected = event.target.value;
        setContainsBlockFunctionId(parseInt(selected));
    };

    const onChangeEventTextArea = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
        const value = event.target.value;
        setContainsConditions(value);
    };

    const onChangeEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const value = event.target.value;
        const field = event.target.name;
        switch (field) {
            case 'positionId':
                setContainsPositionId(parseInt(value));
                break;
            case 'sleepSeconds':
                setContainsSleepSeconds(parseInt(value));
                break;
            default:
                return;
        }
    };

    const close = (): void => {
        setContainsSleepSeconds(0);
        setContainsPositionId(1);
        setContainsConditions('{}');
        setContainsBlockFunctionId(-1);
        closeCallback();
    };

    const savePosition = (): void => {
        const mvnoBlockContains = {} as MvnoBlockContain;
        mvnoBlockContains.positionId = containsPositionId;
        mvnoBlockContains.sleepSeconds = containsSleepSeconds;
        mvnoBlockContains.conditions = containsConditions;
        mvnoBlockContains.mvnoBlockListId = mvnoBlockList.id;
        mvnoBlockContains.mvnoBlockFunctionId = containsBlockFunctionId;
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_contains')),
            'mvno_block_edit_contains_add_new_position',
            mvnoBlockContains,
            (data: MvnoBlockContain): void => {
                reloadContainsList();
                close();
            },
            {
                propagateDataToCallback: true,
                dispatchAfterCallback: false,
            }
        );
    };

    return (
        <Dialog open={open}>
            <DialogContent>
                <GridContainer>
                    <GridItem xs={12}>
                        <Typography variant="h6">{mvnoBlockList.blockName}</Typography>
                    </GridItem>
                    <GridItem xs={12}>
                        <SimpleSelect
                            label="prov:block.choose_block_function"
                            required={true}
                            fieldName="mvnoBlockVunctionId"
                            elements={functionElements}
                            dispatchName={'no-dispatch'}
                            callback={onChangeSelectEvent}
                            selectedValue={containsBlockFunctionId}
                        />
                    </GridItem>
                    <GridItem xs={12}>
                        <CustomInputExtNumber
                            formControlProps={{ fullWidth: true }}
                            required={false}
                            labelText="prov:block.call_position_id"
                            name="positionId"
                            value={containsPositionId}
                            onChange={onChangeEvent}
                        />
                    </GridItem>
                    <GridItem xs={12}>
                        <CustomInputExtNumber
                            formControlProps={{ fullWidth: true }}
                            required={false}
                            labelText="prov:block.sleep_time_before_execute"
                            name="sleepSeconds"
                            value={containsSleepSeconds}
                            onChange={onChangeEvent}
                        />
                    </GridItem>
                    <GridItem xs={12}>
                        <TextareaAutosize
                            id="for-description"
                            style={{ width: '100%', resize: 'none' }}
                            name="description"
                            rowsMin={8}
                            rowsMax={8}
                            onChange={onChangeEventTextArea}
                            defaultValue={containsConditions}
                        />
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={close} callbackParam={{}} label="general:common.close" size="sm" />
                <CustomTextButtom callback={savePosition} callbackParam={{}} label="prov:block.save_new_position" size="sm" />
            </DialogActions>
        </Dialog>
    );
};
